// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--3f479","Chat":"Chat--38J8Z","Collapse":"Collapse--2tsKE","ChatUnselected":"ChatUnselected--A2cLQ"};